import styled from 'styled-components';
import { white, contiOrange } from '../../../style/colors';

const Container = styled.div`
  background: linear-gradient(to bottom, ${white} 0%, #fafafa 100%);
  border-bottom: 1px solid #e5e7eb;
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 24px;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
`;

export const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  i {
    font-size: 24px;
    color: ${contiOrange};
  }
`;

export const StatLabel = styled.span`
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
`;

export const StatValue = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-left: 8px;
`;

export default Container;
